<template>
  <AppDialog
    key="InsightsMeetingsDialog"
    append-to-body
    :show="show"
    size="medium"
    title="Meetings details"
    class="insights-meetings-widget-dialog"
    @close="closeDialog"
  >
    <InsightsMeetingsDialogDetails />
    <InsightsMeetingsDialogInsights v-if="hasAverages" />
    <InsightsMeetingsDialogTimeOfDay />
    <InsightsMeetingsDialogRanking v-if="hasRanking" />

    <template #action>
      <button
        class="close"
        type="button"
        data-dismiss="modal"
        aria-hidden="true"
        @click="closeDialog"
      >
        <i class="hi hi-close hi-10" />
      </button>
    </template>
  </AppDialog>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import InsightsMeetingsDialogDetails from '~/components/insights/InsightsMeetingsDialogDetails.vue';
import InsightsMeetingsDialogTimeOfDay from '~/components/insights/InsightsMeetingsDialogTimeOfDay.vue';
import InsightsMeetingsDialogInsights from '~/components/insights/InsightsMeetingsDialogInsights.vue';

export default {
  name: 'InsightsMeetingsDialog',
  components: {
    InsightsMeetingsDialogDetails,
    InsightsMeetingsDialogTimeOfDay,
    InsightsMeetingsDialogInsights,
    // We will only have data for these components in Milestone 2, but we still want to be able to A/B test them.
    // As such, we have added lazy loading and instead of always displaying them with "no data".
    InsightsMeetingsDialogRanking: defineAsyncComponent(() => import('~/components/insights/InsightsMeetingsDialogRanking.vue')),
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  computed: {
    ...mapGetters(['meetings']),
    hasAverages() {
      return this.meetings.averages?.length;
    },
    hasRanking() {
      return this.meetings.ranking?.length;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
